export default __webpack_public_path__ + "static/media/10.c4bbe99e.jpg";